<!--END ABOUT US-->
<section class="section bg-light" id="aboutUs">
  <div class="container">
    <div class="row vertical-content">
      <div class="col-lg-5 width100">
        <div class="features-box">
          <h3>FEATURES</h3>
          <p class="text-muted web-desc">The <b>Cryptocurrency project support system</b> is created by tokenomics specialists, programmers and scientists <b>based on an Algebraic Approach and AI methods</b>.
          <br><br>
          This service will provide unique opportunities to investors, crypto project owners and developers, which includes, but is not limited to:
        <br><ul>
          <li>Self-dependent creation of a competitive and self-managed token economy, research of its properties and possible scenarios with the help of an automated service - Tokenomics Constructor;</li>
          <li>Forecasting scenarios of the token economy in real-time due to the analysis of current exchange data and other market information based on AI methods;</li>
          <li>Generation of secure smart contracts that correspond to the established token economy and can be adapted to the appropriate platform and network interfaces;</li>
          <li>Ensuring the monitoring of the functioning of the project's tokenomics with the prediction of possible scenarios, using AI methods and possible prompts for corrective actions for project owners and investors;</li>
          <li>Ensuring comprehensive preparation of the crypto project for launch with the generation of a tokenomics paper, graphical information, and current market data;</li>
          <li>The possibility of using the initial templates of effective tokenomics with the possibility of customization to the customer's needs.</li>
        </ul>
             The service is expected to be tokenized and deployed in the blockchain network. Tokenization involves the introduction of the service's token - ALMOD - which will be used to sell on the stock exchange and pay for the services provided.
          </p>
          <h3>FOR INVESTORS AND POTENTIAL PARTNERS</h3>
          <p class="text-muted web-desc">
            We seek partners and investors to scale the project and create a joint project supporting crypto solutions
            for business.
            <br>
            <br>
            We are happy to discuss and consider any joint activity. Contact by mail:
            <a href="mailto:board@altech.org.uk">board@altech.org.uk</a>
            <br>
            <br>
            More information about our platform under development can be found at the links below:
          </p>
          <table>
            <tr>
              <td><ul>
              <li><a href="assets/documents/Whitepaper.pdf" target="_blank">Whitepaper </a> </li>
              <li><a href="assets/documents/TokenomicsPaper.pdf" target="_blank">Tokenomics Paper </a> </li></ul></td>
              <td></td>
              <td></td>
              <td><ul><li><a href="assets/documents/BusinessPlan.pdf" target="_blank">Business Plan</a> </li>
              <li><a href="https://www.youtube.com/watch?v=ji5-ca_NVN8&ab_channel=ALGEBRAICTECHNOLOGIESLTD" target="_blank">Pitch Deck</a> </li>
            </ul></td>
            </tr>
          </table>

          <!--<ul class="text-muted list-unstyled mt-4 features-item-list">
            <li class="">We put a lot of effort in design.</li>
            <li class="">The most important ingredient of successful website.</li>
            <li class="">Sed ut perspiciatis unde omnis iste natus error sit.</li>
            <li class="">Submit Your Organization.</li>
          </ul>-->
          <!--<a href="https://www.youtube.com/watch?v=ji5-ca_NVN8&ab_channel=ALGEBRAICTECHNOLOGIESLTD"
            class="btn btn-primary mt-4">Learn More <i class="mdi mdi-arrow-right"></i></a> -->
        </div>
      </div>
      <!--<div class="col-lg-7">
        <div class="features-img features-right text-right">
          <img src="assets/images/aboutUs.png" alt="macbook image" class="img-fluid">
        </div>
      </div>-->
    </div>
  </div>
</section>
<!--END ABOUT US-->

<!--START WEBSITE-DESCRIPTION-->
<section class="section section-lg bg-web-desc">
  <div class="bg-overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h2 class="text-white"> BUILD YOUR SUSTAINABLE TOKENOMICS NOW</h2>
        <p class="pt-3 home-desc">TOKENOMICS CONSTRUCTOR is a web platform that allows the use of a unique algebraic
          approach for constructing a self-governing token economy model including but not limited to:</p>
        <div class="pt-3 home-desc">
          <ul class="li_align">
            <li>construction and proving the economic equilibrium</li>
            <li>analyzation of different undesirable properties like centralization</li>
            <li>presentation of the malicious actions of unscrupulous stakeholders</li>
            <li>identification of critical points and weaknesses in the step of tokenomics development and more</li>
          </ul>
        </div>

        <a href="https://tokenomics.expert/" class="btn btn-primary waves-light waves-effect mt-4 mb-5">Try the test
          version for Free</a>
      </div>
    </div>
  </div>
  <div class="bg-pattern-effect bg-pattern-light">
    <!-- <img src="assets/images/bg-pattern-light.png" alt=""> -->
    <svg width="100%" height="43" viewBox="0 0 2002 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.49999V42L1998.5 40V23H1962L1879 33L1758.5 36L1703 29.5L1304.5 21.5C1285.3 15.5 1183.83 24 1135.5 29L636 35.5C455.2 1.89999 136.667 4.16665 0 9.49999Z"
        fill="white" fill-opacity="0.1" />
      <path opacity="0.1"
        d="M0 33.5V41.5L1997.5 42V27H1972.5C1585.3 -21.8 1403.17 6.66666 1360.5 27C1299.7 13.4 1035.17 6 910.5 4C856.1 -6.8 597.5 8.5 475 17.5L0 33.5Z"
        fill="white" />
      <path
        d="M0 31.6689V42.1689L2001.5 41.6689V11.6689L1942.25 18.3143C1910.49 21.8758 1879.21 29.7147 1847.38 32.5593C1799.52 36.8366 1750.41 29.3968 1727 23.6689C1577.8 -8.33114 1367.17 10.3355 1280.5 23.6689C1199.3 40.8689 1126.17 30.8355 1106 23.6689C1023.13 -2.89279 818.252 7.7814 689.669 19.2529C659.224 21.9691 629.271 29.2178 598.77 31.21C559.856 33.7516 520.953 28.0794 502 23.6689C395.2 -8.73115 122.833 15.1689 0 31.6689Z"
        fill="white" />
    </svg>
  </div>
</section>